<template>
  <div class="outofService">
    <Attention text="入力情報に対象外の内容が含まれています。" />
    <p class="outofService__title">大変申し訳ございません。<br />入力された情報は、本商品では占うことができません。</p>
    <div class="outofService__body">
      <p class="outofService__body__heading">下記、いずれかの理由でこのページが表示されています。</p>
      <p class="outofService__body__content">●文字数制限を超えています。本商品で占える文字数は、姓、名それぞれ全角（漢字、ひらがな、カタカナ）３文字以内となります。<br />●占えない漢字が入力されています。<br />●占えない画数の組み合わせが含まれています。</p>
    </div>
    <div class="outofService__foot">
      <BaseButton tag="a" :href="backUrl" label="プロフィール入力に戻る" />
      <a href="/" class="outofService__foot__link">占いTV TOPへ</a>
    </div>
  </div>
</template>


<script>
import Attention from './common/Attention'
import BaseButton from './common/BaseButton'

export default {
  name: 'outofService',
  components:{
    Attention,
    BaseButton
  },
  data() {
    return {
    }
  },
  props: {
    backUrl:{
      type:String,
      default:''
    }
  },
}</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";
.outofService{
  color: $col_base_black;
  max-width: 580px;
  margin: auto;
  padding: 35px 20px;

  &__title{
    font-size: 13px;
    line-height: 21px;
    margin: 35px 0 30px;
  }

  &__body{
    margin-bottom: 44px;

    &__heading{
      font-size: 12px;
      line-height: 35px;
      background: $col_lite_gradient;
      margin: 0 -20px;
      padding: 0 20px;
    }
    &__content{
      font-size: 11px;
      margin-top: 17px
    }
  }
  &__foot{
    padding: 0 10px;

    &__link{
      font-size: 11px;
      margin-top: 25px;
      display: block;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/OutofService.vue